import { render, staticRenderFns } from "./VariableComponent.vue?vue&type=template&id=5e3d8aa3&scoped=true&"
import script from "./VariableComponent.vue?vue&type=script&lang=js&"
export * from "./VariableComponent.vue?vue&type=script&lang=js&"
import style0 from "./VariableComponent.vue?vue&type=style&index=0&id=5e3d8aa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d8aa3",
  null
  
)

export default component.exports